import React, { Fragment } from 'react';
import DesignStatus from '../../../../common/components/DesignStatus/DesignStatus';
import { ProjectApi } from '../../api/project-api';
import { clone } from '../../../../common/common';
import Navbar from '../components/Navbar';
import {
  isProjectCompletedForCustomer,
  isProjectCategoryReleasedForCustomer,
  isProjectInProgressForCustomer,
} from '../utils/projectStatusForCustomer';
import { isConsultancy } from '../../../../common/components/ProjectStatus/utils';

class BriefView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      project: props.project,
      proPlatformAccount: props.proPlatformAccount,
      questions: props.questions,
    };
    this.sendToDesigner = this.sendToDesigner.bind(this);
  }

  sendToDesigner(projectId) {
    const self = this;
    ProjectApi.updateState(
      projectId,
      response => {
        self.setState({ project: response.project, nextProject: response.next_project });
      },
      () => {
        const project = clone(self.state.project);
        project.error = true;
        self.setState({ project });
      },
    );
  }

  showNavBar() {
    const { project } = this.state;
    const completed = isProjectCompletedForCustomer(project);
    const categoryRelease = isProjectCategoryReleasedForCustomer(project);
    const inProgress = isProjectInProgressForCustomer(project);
    return completed || (categoryRelease && inProgress);
  }

  render() {
    const { customer, customerView, hideTimeLine, secretLinkToShare, proPlatformAccount } = this.props;
    const { project } = this.state;
    const inProgress = isProjectInProgressForCustomer(project);
    const categoryRelease = isProjectCategoryReleasedForCustomer(project);
    const consultancy = isConsultancy(project);
    return (
      <Fragment>
        {consultancy || hideTimeLine ? null : (
          <div className="container">
            <DesignStatus project={project} editable={false} customer={customer} customerView={customerView} />
          </div>
        )}
        <div className="container">
          {this.showNavBar() && (
            <Navbar project={project}
                    categoryRelease={inProgress && categoryRelease}
                    secretLinkToShare={secretLinkToShare}
                    proPlatformAccount={proPlatformAccount}
            />
          )}
        </div>
      </Fragment>
    );
  }
}

export default BriefView;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/screens/NavBarView.js